// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-cred-card {
    background: var(--sa-card);
    border-radius: 14px;
    padding: 20px;
    border: 1px solid var(--sa-border);
}

.sa-cred-input {
    width: 100%;
    padding: 10px 14px;
    background: var(--sa-surface);
    border: 1px solid var(--sa-border);
    border-radius: 8px;
    color: var(--sa-text);
    font-size: 13px;
    box-sizing: border-box;
}

.sa-cred-input:focus {
    border-color: var(--sa-accent);
    outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SACredentials.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;AACjB","sourcesContent":[".sa-cred-card {\n    background: var(--sa-card);\n    border-radius: 14px;\n    padding: 20px;\n    border: 1px solid var(--sa-border);\n}\n\n.sa-cred-input {\n    width: 100%;\n    padding: 10px 14px;\n    background: var(--sa-surface);\n    border: 1px solid var(--sa-border);\n    border-radius: 8px;\n    color: var(--sa-text);\n    font-size: 13px;\n    box-sizing: border-box;\n}\n\n.sa-cred-input:focus {\n    border-color: var(--sa-accent);\n    outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
